import { apiClient, getUserId } from "./authService";

export interface GetReportsInput {
  business_id?: string;
  start_date?: string;
  end_date?: string;
  user_id?: string;
}

export interface GetAdminReportsInput extends GetReportsInput {
  venue_id?: string;
}

export const getAllReports = async (
  reportData: GetReportsInput,
  venueId?: string | null
): Promise<any> => {
  try {
    const uid = reportData.user_id ?? getUserId();

    const payload: any = {
      start: reportData.start_date ?? "",
      end: reportData.end_date ?? "",
      user_id: uid ?? "",
    };

    // Only add business_id if it's provided and not empty
    if (reportData.business_id) {
      payload.business_id = reportData.business_id;
    }

    if (!venueId) {
      throw new Error("Venue ID is required to fetch reports");
    }

    const response = await apiClient.post(
      `/getFilteredData/venue/${venueId}`,
      payload
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getAdminReports = async (
  reportData: GetAdminReportsInput
): Promise<any> => {
  try {
    const uid = reportData.user_id ?? getUserId();

    const payload: any = {
      start: reportData.start_date ?? "",
      end: reportData.end_date ?? "",
      user_id: uid ?? "",
    };

    if (reportData.business_id) {
      payload.business_id = reportData.business_id;
    }

    if (reportData.venue_id) {
      payload.venue_id = reportData.venue_id;
    }

    const response = await apiClient.post("/getFilteredData/Allvenues", payload);
    return response.data;
  } catch (error) {
    throw error;
  }
};
